// Cookie names
// The names for the tokens come from token.token_type
export const RefreshToken = 'RefreshToken'
export const AccessToken = 'ConnectedUser'
export const TemporaryToken = 'TemporarySession'
export const UserData = 'UserData'
